var map = {
	"./IMG_3735.jpeg": 8284,
	"./midGal1.37e33487.JPG": 4973,
	"./midGal2.d8c054a1.JPG": 1017,
	"./midGal4.9013c0ed.JPG": 9219,
	"./midGal5.2f184ada.jpg": 2387
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8910;